import { InfoMessage } from 'components';
import Label from 'components/fieldLabel';

  
  export const equipmentDocs = () =>
  [
    {
      label: "Παραστατικό Πώλησης",
      fileCode: 'INVOICE',
      id: 'INVOICE',
      multiple: false,
      fileLimit: 10,
      required: true,
    },
    {
      // label: "Δελτίο Αποστολής",
      label: <div style={{display:'flex', alignItems: 'center'}}>
        <Label 
          label="Δελτίο Αποστολής"
          customClass={'drag-label-version2'}
        />
        <InfoMessage
          infoMessage={'Σε περίπτωση που το Δελτίο Αποστολής ταυτίζεται με το Παραστατικό Πώλησης, θα πρέπει να ανέβει εκ νέου και σε αυτό το πεδίο.'}
          overlayClassName={'multiline-info-message'}
          placement='right'
        />
      </div>,
      fileCode: 'SHIPMENT',
      id: 'SHIPMENT',
      multiple: false,
      fileLimit: 10,
      required: true,
    },
    {
      label: " Άλλο Έγγραφο",
      fileCode: 'OTHER',
      id: 'OTHER',
      multiple: false,
      fileLimit: 10
    },
  ].filter(item => item);